export const ENDPOINTS = {
    token: "/ui-service/api/v1/status/token",
    metadata: "/ui-service/api/v1/status/metadata",
    regions: "/api/v1/status/processor/regions",
    products: "/api/v1/status/processor/products",
    uiProducts: "/api/v1/status/processor/products/ui",
    incidents: "/api/v1/status/processor/incidents",
    maintenances: "/api/v1/status/processor/maintenances",
    advisories: "/api/v1/status/processor/advisories",
    subscriptions: "/api/v1/status/subscriptions",
    subscribeIncident: (id) => `/api/v1/status/subscriptions/incident/${id}`,
    subscribeMaintenance: (id) => `/api/v1/status/subscriptions/maintenance/${id}`,
    subscribeAdvisory: (id) => `/api/v1/status/subscriptions/advisory/${id}`,
    unsubscribe: "/api/v1/status/notification/unsubscribe",
    requestOtp: "/api/v1/status-page/otp-service/request-otp",
    verifyOtp: "/api/v1/status-page/otp-service/verify-otp",
    health: "/api/v1/status/processor/health",
    notificationHealth: "/api/v1/status/health",
};
